import { render, staticRenderFns } from "./Breakout.vue?vue&type=template&id=fefb0c70&scoped=true"
import script from "./Breakout.vue?vue&type=script&lang=js"
export * from "./Breakout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefb0c70",
  null
  
)

export default component.exports